import { Icon } from '@mdlbeasts/nofomo.ui.web';
import { Stack, useTheme } from '@mui/material';

import { useAffiliatePartner } from 'services/stores/affiliate/hooks';
import { ImageFileFragment } from 'types/api/dato-operations.types';

import DatoImage from 'components/@common/DatoImage';

/**
 * Affiliate partner logo.
 * @constructor
 */
export const AffiliateHeadingLogo = () => {
  const theme = useTheme();

  /**
   * Store to get the current affiliate partner.
   */
  const partner = useAffiliatePartner();

  if (!partner?.headingLogo) {
    return null;
  }

  return (
    <Stack
      direction="row"
      ml="10px"
      sx={{
        gap: '10px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'none',
      }}
    >
      <Icon name="Close" fontSize={16} />
      <Stack
        direction="row"
        sx={{
          width: 70,
          height: 24,
          position: 'relative',
        }}
      >
        <DatoImage
          fill
          priority
          data={partner?.headingLogo as ImageFileFragment}
          sizes="256px"
          style={{
            objectFit: 'contain',
            objectPosition:
              theme.direction === 'rtl' ? 'right center' : 'left center',
          }}
        />
      </Stack>
    </Stack>
  );
};
